import React from 'react';
import DashBoard from './DashBoard';
import Navigation from './MenuBar';
import Products from './Products'
import Orders from './orders/index';
import Statements from './statements/index';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { HashRouter as Router, Route, Switch } from 'react-router-dom';


const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#ffffff',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contast with palette.primary.main
    },
    secondary: {
      light: '#222',
      main: '#222',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // error: will use the default color
  },
});

class App extends React.Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <MuiThemeProvider theme={theme}>
              <Navigation />
              <Route path="/products" component={Products} />
              <Route path="/orders" component={Orders} />
              <Route path="/orders/:shippingTime" component={Orders} />
              <Route path="/statements" component={Statements} />
              <Route exact path="/" component={DashBoard} />
            </MuiThemeProvider>
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx